import { ReactNode } from 'react';

import Box from 'UIKit/Box';

import styles from './tag.module.scss';

interface TagProps {
  text: ReactNode;
  className?: string;
}

const Tag = (props: TagProps) => {
  const { text, className } = props;
  return <Box className={`${styles.tag} ${className}`}>{text}</Box>;
};

export default Tag;
